import {Grid, Surface, Tab, useTheme} from "tmwx-design-web/src";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {usePermissions} from "tmwx-design-common";
import {useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import {RootState} from "gui-common/redux/store";
import {Code, Script} from "gui-common/redux/data/pythonScript";
import {isEmpty} from "gui-common/appHelper";
import CodeSearchModal from "../../components/efe/CodeSearchModal";
import constants from "gui-common/constants.json";
import {getEventList, getScript, getVariablesList} from "gui-common/redux/action/efe/pythonScriptAction";
import {pythonScriptActions} from "gui-common/redux/slice/efe/pythonScriptSlice";
import EventTable from "../../components/efe/EventTable";
import VariablesTable from "../../components/efe/VariablesTable";
import ScriptDetails from "../../components/efe/ScriptDetails";

const PythonScript = () => {
    const {t} = useTranslation()
    const {padding, roundness} = useTheme()
    const dispatch: any = useDispatch()
    const {hasRights} = usePermissions()
    const [label, setLabel] = useState<string>('');
    const [searchParams, setSearchParams] = useSearchParams();
    const selectedCode = useSelector<RootState, Code>(state => state.pythonScript.selectedCode)
    const scriptD = useSelector<RootState, Script>(state => state.pythonScript.script)

    useEffect(() => {
        if (!isEmpty(selectedCode.ptcPyCodeName) && !isEmpty(selectedCode.ptcPyCodeTag)) {
            setLabel(selectedCode.ptcPyCodeName + ' - ' + selectedCode.ptcPyCodeTag)
            const codeTag = selectedCode.ptcPyCodeTag
            const codeName = selectedCode.ptcPyCodeName
            setSearchParams({ codeTag, codeName });

            if (hasRights(["efe_python_script_view"])) {
                dispatch(getScript(selectedCode.ptcPyCodeTag))
                dispatch(getVariablesList(selectedCode.ptcPyCodeTag))
                dispatch(getEventList(selectedCode.ptcPyCodeTag))
            }
        }
    }, [selectedCode])

    useEffect(() => {
        const codeTag = localStorage.getItem(constants.CODE_TAG);
        const codeName = localStorage.getItem(constants.CODE_NAME);

        if (codeTag != null  && codeName != null) {
            dispatch(pythonScriptActions.setSelectedCode({
                ptcPyCodeTag: codeTag,
                ptcPyCodeName: codeName,
                ptcId: -1
            }))
        }
    }, [dispatch])

    return (
        <Surface style={{height: '100vh', paddingTop: 8, paddingBottom: 8}}>
            <Grid.Container style={{borderRadius: roundness}} maxWidth='xl' elevation={0} centered>
                <Grid.Col m={6} lg={6} xl={6}>
                    <CodeSearchModal label={label}/>
                </Grid.Col>

                <Grid.Col>
                    {!isEmpty(selectedCode) && !isEmpty(scriptD) &&
                        <Tab
                            elevation={0}
                            contentMode='keep'
                            menuItems={[
                                {
                                    title: t('details'),
                                    icon: 'info_outlined',
                                    component: (
                                        <ScriptDetails />
                                    )
                                },
                                {
                                    title: t('efe.variables'),
                                    icon: 'info_outlined',
                                    component: (
                                        <VariablesTable />
                                    )
                                },
                                {
                                    title: t('events'),
                                    icon: 'info_outlined',
                                    component: (
                                        <EventTable />
                                    )
                                }
                            ]}
                        />
                    }
                </Grid.Col>
            </Grid.Container>
        </Surface>
    )
}

export default PythonScript;